import React from "react";
import {
  Box,
  Grid,
  Slide,
  Typography,
  CardMedia,
  Stack,
  Link,
} from "@mui/material";

import { HeaderStyle, TertiaryStyle } from "../fonts";

import Kim from "../assets/kim.webp";
import Banner from "../assets/banner.webp";
import Logo from "../assets/logo.webp";

const BackCover = (props) => {
  const { checked } = props;

  return (
    <Slide
      direction={"left"}
      in={checked}
      timeout={{
        enter: 1750,
        exit: 1750,
      }}
    >
      <Box
        sx={{
          height: { xs: "100svh", sm: "100vh" },
          width: "100%",
          bgcolor: "#D7D7D7",
        }}
      >
        <Grid
          container
          sx={{
            height: "100%",
            justifyContent: "center",
          }}
        >
          <Grid item xs={12} sm={9} lg={6}>
            <Grid
              container
              direction={"column"}
              sx={{ height: "100%", backgroundColor: "#FFFFFF" }}
            >
              <Grid
                item
                xs
                sx={{
                  borderLeft: "1vh solid #fff",
                  borderRight: "1vh solid #fff",
                  borderTop: "1vh solid #fff",
                }}
              >
                <CardMedia
                  component={"iframe"}
                  sx={{
                    minHeight: { lg: "55vh" },
                    border: 0,
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "8px",
                  }}
                  src="https://unbranded.youriguide.com/602_delaware_ave_n_toronto_on?page=tour&pano=20011&rotation=-3.3630256483665755&elevation=-0.1808401146540758"
                />
              </Grid>
              <Grid
                item
                xs
                sx={{
                  zIndex: 1,
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  borderBottom: ".5vh solid #ba2525",
                }}
              >
                <Typography
                  sx={{
                    ...HeaderStyle,
                    color: "#ba2525",
                    "@media (orientation: landscape)": {
                      fontSize: { xs: "2.4vw", lg: "2.2vw" },
                      lineHeight: { xs: "2.5vw", md: "2vw", lg: "2.1vw" },
                      paddingTop: { xs: "0vh", lg: "3vh" },
                    },
                    "@media (orientation: portrait)": {
                      fontSize: { xs: "7vw", sm: "5vw" },
                      lineHeight: { xs: "3.3vh", md: "3.5vh" },
                      paddingTop: { xs: "2vh", md: "3vh" },
                    },
                  }}
                >
                  602 Delaware Avenue
                </Typography>
              </Grid>

              <Stack
                sx={{
                  height: "20%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Stack direction={"row"}>
                  <CardMedia
                    component={"img"}
                    sx={{
                      pl: 2,
                      pr: 1,
                      borderRadius: "50%",
                      maxHeight: { xs: 60, md: 110 },
                      maxWidth: { xs: 60, md: 110 },
                      width: "auto",
                      height: "auto",
                      objectFit: "contain",
                    }}
                    src={Kim}
                  />
                  <Grid item xs>
                    <Box
                      height={"90%"}
                      sx={{
                        mt: { xs: 0, md: -2 },
                        display: "flex",
                        justifyContent: "flex-end",
                        flexDirection: "column",
                        backgroundImage: `url('${Logo}')`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "left-top",
                        zIndex: -1,
                      }}
                    />
                    <Stack direction={"row"} sx={{ mt: -1 }}>
                      <Typography
                        sx={{
                          ...TertiaryStyle,
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Contact:
                      </Typography>
                      <Typography
                        sx={{
                          ...TertiaryStyle,
                        }}
                      >
                        <Link
                          href="mailto:kim@kimkehoe.com"
                          sx={{ textDecoration: "none", color: "#ba2525" }}
                        >
                          kim@kimkehoe.com&nbsp;
                        </Link>
                        <Link
                          href="tel:416-788-1823"
                          sx={{ textDecoration: "none", color: "#ba2525" }}
                        >
                          | 416-788-1823
                        </Link>
                      </Typography>
                    </Stack>
                    <Stack direction={"row"}>
                      <Typography
                        sx={{
                          ...TertiaryStyle,
                          color: "black",
                          fontWeight: 400,
                        }}
                      >
                        Website:
                      </Typography>
                      <Typography
                        sx={{
                          ...TertiaryStyle,
                        }}
                      >
                        <Link
                          sx={{ textDecoration: "none", color: "#ba2525" }}
                          href="http://www.kimkehoe.com"
                        >
                          www.kimkehoe.com
                        </Link>
                      </Typography>
                    </Stack>
                  </Grid>
                </Stack>
                <Grid
                  item
                  xs={4}
                  sx={{
                    pr: 3,
                    height: "60%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                  }}
                >
                  <Box
                    sx={{
                      width: "80%",
                      height: "100%",
                      display: "flex",

                      flexDirection: "column",
                      backgroundImage: `url('${Banner}')`,
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                    }}
                  />
                  <Stack
                    direction={"row"}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "77%",
                    }}
                  >
                    <Typography
                      sx={{
                        ...TertiaryStyle,
                        color: "black",
                        fontWeight: 400,
                      }}
                    >
                      Office:
                    </Typography>
                    <Typography
                      sx={{
                        ...TertiaryStyle,
                      }}
                    >
                      <Link
                        sx={{ textDecoration: "none", color: "#ba2525" }}
                        href="tel:416-530-1100"
                      >
                        416-530-1100
                      </Link>
                    </Typography>
                  </Stack>
                </Grid>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Slide>
  );
};

export default BackCover;
